import { useState } from "react";

// redux
import { useStore } from "react-redux";
import { success, error as toastError } from "hyc-store/reducers/toast";

// components
import { Button } from "shared/components/bulma/button";

import * as helper from "./helper";

const ExemptButton = ({ box }) => {
    const [newBox, setNewBox] = useState(box);

    const store = useStore();

    const handleClick = async () => {
        try {
            await helper.exemptLateBox(newBox);
            store.dispatch(success('Success! The customer is now exempted!'));
            newBox.exempted = true;
            setNewBox({ ...newBox });
        } catch (error) {
            store.dispatch(toastError(error.message));
        };
    };

    const buttonClasses = [
        'button is-info',
        newBox.exempted ? '' : 'is-outlined'
    ].join(' ');

    const value = newBox.exempted ? "Exempted" : "Exempt";

    return (
        <Button name="exempt" className={buttonClasses}
            onClick={handleClick}>
            {value}
        </Button>
    )
}

export { ExemptButton };
